import {classNames} from "../../../utils/utils";

export default function UploadResultMessages({error}) {
  return <div className='flex'>
    <p className={classNames(!error ? 'text-Promote' : 'text-Error', ' text-[15px] leading-[20px] font-medium secondary-font')}>
      {!error ? 'Upload successful!' : 'Invalid CSV/Excel file'}
    </p>
  </div>
}